export const UPDATE_POOLS = 'POOLS/UPDATE_POOLS';
export const UPDATE_POOL = 'POOLS/UPDATE_POOL';
export const DELETE_POOL = 'POOLS/DELETE_POOL';
export const CREATE_POOL = 'POOLS/CREATE_POOL';
export const SHARE_POOL = 'POOLS/SHARE_POOL';
